/* eslint-disable */
import $ from 'jquery';

'use strict';

const CheckoutFormPersistence = {
	STORAGE_KEY: 'checkout_form_data',

	saveFormData: function() {
		const formData = {};
		const fields = [
			'billing_first_name', 'billing_last_name', 'billing_company', 'billing_email',
			'billing_phone', 'billing_address_1', 'billing_address_2',
			'billing_city', 'billing_state', 'billing_postcode', 'billing_country',
			'shipping_first_name', 'shipping_last_name', 'shipping_company', 'shipping_address_1',
			'shipping_address_2', 'shipping_city', 'shipping_state',
			'shipping_postcode', 'shipping_country'
		];
		fields.forEach(fieldName => {
			const $field = $(`#${fieldName}`);
			if ($field.length) {
				formData[fieldName] = $field.val();
			}
		});
		const $shipToDifferent = $('#ship-to-different-address-checkbox');
		if ($shipToDifferent.length) {
			formData.ship_to_different_address = $shipToDifferent.is(':checked');
		}
		sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(formData));
	},

	restoreFormData: function() {
		const savedData = sessionStorage.getItem(this.STORAGE_KEY);
		if (!savedData) return;
		try {
			const formData = JSON.parse(savedData);
			Object.keys(formData).forEach(fieldName => {
				if (fieldName === 'ship_to_different_address') {
					const $checkbox = $('#ship-to-different-address-checkbox');
					if ($checkbox.length && formData[fieldName]) {
						$checkbox.prop('checked', true).trigger('change');
					}
				} else {
					const $field = $(`#${fieldName}`);
					if ($field.length) {
						$field.val(formData[fieldName]).trigger('change');
						// if is select2, trigger select2:select
						if ($field.hasClass('select2-hidden-accessible')) {
							$field.trigger({
								type: 'select2:select',
								params: {
									data: $field.select2('data')
								}
							});
						}
					}
				}
			});
		} catch (e) {
			console.error('Error restoring form data:', e);
		}
	},

	clearFormData: function() {
		sessionStorage.removeItem(this.STORAGE_KEY);
	},

	bindEvents: function() {
		const self = this;
		$(document).on('click', 'button[name="apply_coupon"], input[name="apply_coupon"], .apply-coupon', function() {
			self.saveFormData();
		});
		$(document).on('submit', 'form[name="checkout_coupon"], .coupon-form, form.woocommerce-form-coupon', function() {
			self.saveFormData();
		});
		$(document).on('blur', 'form.checkout input, form.checkout select, form.checkout textarea', function() {
			self.saveFormData();
		});
		// Added: also react to change event
		$(document).on('change', 'form.checkout input, form.checkout select, form.checkout textarea', function() {
			self.saveFormData();
		});
		$(document).on('wc_checkout_complete', function() {
			self.clearFormData();
		});
	},

	init: function() {
		if (!$('body').hasClass('woocommerce-checkout')) return;
		this.restoreFormData();
		this.bindEvents();
	}
};

export default CheckoutFormPersistence;